import LoaderIcon from './images/loader.svg?react';

import styles from './LoaderSpinner.module.scss';

const LoaderSpinner = () => {
  return <LoaderIcon className={styles.loaderSpinner} />;
};

export default LoaderSpinner;
